import type { AxiosResponse } from 'axios';
import { jwtDecode } from 'jwt-decode';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import SubAbasUser from './SubAbasUser';
import BarraInferiorBotoes from '../../../components/BarraInferiorBotoes';
import BarraSubAbas from '../../../components/BarraSubAbas';
import BoxConteudo from '../../../components/BoxConteudo';
import ContainerConteudo from '../../../components/ContainerConteudo';
import CustomCol from '../../../components/CustomCol';
import CustomRow from '../../../components/CustomRow';
import CustomSpan from '../../../components/CustomSpan';
import Input from '../../../components/InputNew';
import Select from '../../../components/InputNew/Select';
import SelectInput from '../../../components/InputNew/Select';
import StyledLink from '../../../components/Link';
import Log from '../../../components/Log/Log';
import Modal from '../../../components/Modal';
import SubAbas from '../../../components/SubAbas';
import Tabela from '../../../components/Tabela';
import WorkspaceBotoes from '../../../components/WorkspaceBotoes';
import WorkspaceFicha from '../../../components/WorkspaceFicha';
import BolinhaTabelaStatus from '../../../components/bolinhaTabelaStatus';
import { getUser } from '../../../modules/contexts/Auth/RequireAuth';
import { usePasswordValidation } from '../../../modules/hooks/usePasswordValidation';
import { LogData } from '../../../modules/types/types';
import { useCor } from '../../../services/enum/useCorPele';
import { useGeneros } from '../../../services/enum/useGeneros';
import { usePapelUsuario } from '../../../services/enum/usePapelUsuario';
import { useUnidadeDAF } from '../../../services/enum/useUnidadeDaf';
import httpClient, { isHttpError } from '../../../services/httpClient';
import { getUserData } from '../../../services/userService';
import { useUserIdData } from '../../../services/usuario/useUserIdData';
import {
  getUserAlocacao,
  getUserPapel,
  getUserPermissao,
} from '../../../services/usuario/userService';
import { formataNomeMeioSiglas, formatDt } from '../../../utils/functions';
import {
  swal,
  swalAtualizacao,
  swalDelete,
  swalErro,
} from '../../../utils/swal';
import { valoresExibidosLog as valoresExibidos } from '../MeusDados/auxiliarMeusDados';

const FichaUsuario: React.FC = () => {
  // Parâmetro da URL
  const { id } = useParams<{ id?: string }>();
  const params = useParams();
  const fichaID = String(params.id);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [error, setError] = useState<string | null>(null);
  // Dados do usuário e estado do formulário
  const { formData, setFormData } = useUserIdData();
  const user = getUser();
  const userID = user.sub;
  const [logDataAlocacao, setLogDataAlocacao] = useState<LogData>();
  const [logDataPapel] = useState<LogData>();
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [logDataPermissao, setLogDataPermissao] = useState<LogData>();

  // Controle de visibilidade dos modais
  const [showModal, setShowModal] = useState<boolean>(false);
  const [showModalAlocacao, setShowModalAlocacao] = useState<boolean>(false);
  const [updatingAlocacao, setUpdatingAlocacao] = useState<boolean>(false);
  const [alocacaoIdToDelete, setAlocacaoIdToDelete] = useState<number | null>(
    null,
  );
  const [showModalPapel, setShowModalPapel] = useState<boolean>(false);
  const [updatingPapel] = useState<boolean>(false);
  const [papelIdToDelete] = useState<number | null>(null);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [showModalPermissao, setShowModalPermissao] = useState<boolean>(false);

  // Funções para alternar modais
  const handleModal = () => setShowModal((prev) => !prev);
  const handleModalAlocacao = () => setShowModalAlocacao((prev) => !prev);
  const handleModalPapel = () => setShowModalPapel((prev) => !prev);

  // Modais adicionais
  const [alocacoes, setAlocacoes] = useState<any[]>([]);
  const [papeis, setPapeis] = useState<any[]>([]);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [permissoes, setPermissoes] = useState<any[]>([]);

  // Títulos e ícones dos modais
  const tituloModal = 'Alterar Senha';
  const iconeModal = 'key';

  // Hook para obter dados
  const generos = useGeneros();
  const cores = useCor();
  const papelUsuario = usePapelUsuario();
  const unidadeDAF = useUnidadeDAF();

  const [userRole, setUserRole] = useState<number | null>(null); // Papel do usuário

  useEffect(() => {
    const fetchUserRoleAndUnit = async () => {
      try {
        const token = localStorage.getItem('token');
        if (!token) {
          throw new Error('Token não encontrado.');
        }

        const decodedToken: any = jwtDecode(token); // Decodifica o token
        const { papel, unidade } = decodedToken; // Obtém papel e unidade

        if (Array.isArray(papel) && papel.length > 0) {
          setUserRole(papel[0]); // Define o papel do usuário
        } else {
          setError('Papel do usuário não encontrado no token.');
          //console.error('Papel do usuário não encontrado no token.');
        }

        if (unidade) {
          setFormData((prev) => ({
            ...prev,
            unidadeCadastro: unidade, // Define a unidade do usuário logado no formData
          }));
        } else {
          setError('Unidade do usuário não encontrada no token.');
          //  console.error('Unidade do usuário não encontrada no token.');
        }
      } catch (error) {
        setError('Erro ao obter papel ou unidade do usuário');
        //  console.error('Unidade do usuário não encontrada no token.');
      }
    };

    fetchUserRoleAndUnit();
  }, []);

  //SENHA -  validar a senha do usuário
  const [senha, setSenha] = useState<string>('');
  const [confirmaSenha, setConfirmaSenha] = useState<string>('');

  const [validLength, passwordMatch] = usePasswordValidation({
    firstPassword: senha,
    secondPassword: confirmaSenha,
  });

  const [passwordDigits, setPasswordDigits] = useState<number>(0);

  const validaSenhaTamanho = () => {
    if (passwordDigits > 0 && !validLength) {
      swal(
        'error',
        'Senha inválida',
        'A senha deve conter no mínimo 6 caracteres!',
      );
      setSenha('');
      handleModal();
    }
  };

  const validaSenhaConfirma = () => {
    if (passwordDigits >= 6 && !passwordMatch) {
      swal('error', 'Senha inválida', 'As senhas digitadas não são iguais!');
      setConfirmaSenha('');
      handleModal();
    }
  };
  const handleChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>,
  ) => {
    const { name, value } = event.target;

    const enumFields = [
      'genero',
      'cor',
      'tipoVinculo',
      'orgaoOrigem',
      'unidadeCadastro',
      'papelUsuario',
      'moduloUsuario',
    ];

    const newValue = enumFields.includes(name) ? Number(value) : value;

    setFormData((prev) => {
      const updatedForm = {
        ...prev,
        [name]: newValue,
      };

      // Quando tipoVinculo for "Consultor Técnico", limpa campos relacionados
      if (name === 'tipoVinculo' && ['1', '4'].includes(String(newValue))) {
        updatedForm.orgaoOrigem = '0';
        updatedForm.outroOrgao = '';
      }

      return updatedForm;
    });
  };

  // Validação

  const validateForm = () => {
    const errors: { [key: string]: string } = {};

    // Validação do tipoVinculo (campo obrigatório)
    if (!formData.tipoVinculo || !String(formData.tipoVinculo).trim()) {
      errors.tipoVinculo = 'O campo "Tipo de Vínculo" é obrigatório.';
    }

    // Validação do tipoVinculo e orgaoOrigem
    if (
      !['1'].includes(String(formData.tipoVinculo)) && // Se tipoVinculo não está na lista válida
      !formData.orgaoOrigem // orgaoOrigem é obrigatório
    ) {
      errors.orgaoOrigem = 'O campo "Orgão de Origem" é obrigatório.';
    }

    // Validação de outroOrgao quando orgaoOrigem é "6"
    if (
      String(formData.orgaoOrigem) === '6' && // orgaoOrigem == "Outro"
      (!formData.outroOrgao || !formData.outroOrgao.trim()) // outroOrgao vazio ou apenas espaços
    ) {
      errors.outroOrgao =
        'O campo "Outro Órgão" é obrigatório quando Orgão de Origem é "Outro".';
    }

    return errors;
  };

  const handleSenhaChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSenha(e.target.value);
    setPasswordDigits(e.target.value.length);
  };

  const handleConfirmaSenhaChange = (
    e: React.ChangeEvent<HTMLInputElement>,
  ) => {
    setConfirmaSenha(e.target.value);
  };

  useEffect(() => {
    if (id) {
      const fetchData = async () => {
        try {
          const userData = await getUserData(id);
          setFormData(userData);

          const userAlocacaoData = await getUserAlocacao(fichaID);
          setAlocacoes(userAlocacaoData);

          const userPapelData = await getUserPapel(fichaID);
          setPapeis(userPapelData);

          if (userPapelData.length > 0) {
            setFormPapel((prevState) => ({
              ...prevState,
              papelUsuario: userPapelData[0].papelUsuario,
              dataInicio: userPapelData[0].dataInicio,
              dataFim: userPapelData[0].dataFim,
              observacoes: userPapelData[0].observacoes,
              status: userPapelData[0].status,
            }));
          }

          const userPermissaoData = await getUserPermissao(fichaID);
          setPermissoes(userPermissaoData);
        } catch (error) {
          console.error('Erro ao obter dados:', error);
        }
      };
      fetchData();
    }
  }, [id, setFormData]);

  //UPDATE USER
  const updateData = async () => {
    const validationErrors = validateForm();

    // Filtrar apenas os erros relevantes
    const relevantErrors = Object.keys(validationErrors).filter((key) =>
      ['tipoVinculo', 'orgaoOrigem', 'outroOrgao'].includes(key),
    );

    if (relevantErrors.length > 0) {
      const errorMessages = relevantErrors
        .map((key) => validationErrors[key])
        .join('\n'); // Formata mensagens para exibição
      console.error('Validação falhou:', validationErrors);
      swal(
        'error',
        'Por favor, corrija os seguintes erros:',
        `\n\n${errorMessages} `,
      );
      return;
    }

    try {
      // Normaliza os dados para envio
      const sanitizedData = {
        ...formData,
        tipoVinculo: formData.tipoVinculo ?? 0,
        orgaoOrigem: formData.orgaoOrigem
          ? parseInt(formData.orgaoOrigem, 10)
          : 0,
        outroOrgao: formData.outroOrgao || '',
      };

      //  console.log('Dados enviados para a API:', sanitizedData);

      const response = await httpClient.patch(
        `/api/users/${id}`,
        sanitizedData,
      );

      swalAtualizacao('Sucesso', response.data.message);
      // setTimeout(() => window.location.reload(), 1000);
    } catch (error) {
      console.error('Erro ao atualizar dados:', error);
      swal(
        'error',
        'Algo deu errado... Alterações não foram realizadas com sucesso. Tente novamente.',
        'error',
      );
    }
  };

  //UPDATE SENHA
  const updateSenha = async () => {
    try {
      if (!validLength || !passwordMatch)
        throw new Error(
          'As senhas devem ter no mínimo 6 caracteres e serem iguais.',
        );

      const response = await httpClient.patch(`/api/users/${id}/senha`, {
        novaSenha: senha,
      });

      if (response.status === 200) {
        setShowModal(false);
        setSenha('');
        setConfirmaSenha('');
        swalAtualizacao('Sucesso', response.data.message);
      } else {
        throw new Error('Erro ao atualizar senha');
      }
    } catch (error) {
      console.error('Erro ao alterar senha:', error);
      swal(
        'error',
        'Erro ao alterar senha',
        'As senhas devem ter no mínimo 6 caracteres e serem iguais.',
      );
    }
  };

  //MODULO ALOCACAO
  // Estado formulario
  const [formAlocacao, setFormAlocacao] = useState({
    unidadeDAF: 0,
    setor: '',
    dataInicio: '',
    dataFim: '',
    observacoes: '',
    usuarioRegistroId: userID,
    alocacaoId: null,
    status: 'N',
  });

  // Mostrar modal para Add Alocacao
  // const handleClickInserirNovoAlocacao = () => {
  //   handleClearFormAlocacao();
  //   setUpdatingAlocacao(false);
  //   handleModalAlocacao();
  // };

  // Função trata linha ao clicar
  const handleRowClickAlocacao = (id: number) => {
    const selectedAlocacao = alocacoes.find((item) => item.id === id);

    if (selectedAlocacao) {
      // Configurações iniciais
      setAlocacaoIdToDelete(id);
      setUpdatingAlocacao(true);
      setShowModalAlocacao(true);

      // Define os valores no formulário de alocação
      setFormAlocacao({
        unidadeDAF: selectedAlocacao.unidadeDAF,
        setor: selectedAlocacao.setor,
        dataInicio: selectedAlocacao.dataInicio
          ? selectedAlocacao.dataInicio.split('T')[0]
          : '',
        dataFim: selectedAlocacao.dataFim
          ? selectedAlocacao.dataFim.split('T')[0]
          : '',
        observacoes: selectedAlocacao.observacoes,
        status: selectedAlocacao.status,
        //status: <BolinhaTabelaStatus status={selectedAlocacao.status} />,
        usuarioRegistroId: userID,
        alocacaoId: selectedAlocacao.id,
      });

      // Define os dados do log
      setLogDataAlocacao({
        id: selectedAlocacao.id,
        usuarioRegistro: selectedAlocacao.usuarioRegistro?.nomeCompleto || '',
        usuarioAtualizacao:
          selectedAlocacao.usuarioRegistro?.nomeCompleto || '',
        dataRegistro: selectedAlocacao.dataRegistro || '',
        dataAtualizacao: selectedAlocacao.dataUltimaAtualizacao || '',
        nEdicoes: selectedAlocacao.nEdicoes || 0,
      });
    }
  };

  //TABELA HEADERS
  const headersAlocacao = [
    { text: '', width: 2, key: '' },
    { text: 'ID', width: 2, key: 'id' },
    { text: 'Status', width: 1, key: 'status' },
    { text: 'Alocação', width: 15, key: 'unidadeDAF' },
    { text: 'Setor', width: 15, key: 'setor' },
    { text: 'Data Início', width: 15, key: 'dataInicio' },
    { text: 'Data Fim', width: 15, key: 'dataFim' },
  ];

  const tableDataAlocacao = alocacoes.map((item) => ({
    id: item.id,
    status: <BolinhaTabelaStatus status={item.status} />,
    Alocação: unidadeDAF[item.unidadeDAF]?.label || 'Unidade Desconhecida',
    Setor: item.setor,
    'Data Início': formatDt(item.dataInicio),
    'Data Fim': item.dataFim ? formatDt(item.dataFim) : 'N/A',
  }));

  const offCanvasDataAlocacao = alocacoes.map((item) => ({
    id: item.id,
    dataRegistro:
      formatDt(item.dataRegistro) +
      ' - ' +
      formataNomeMeioSiglas(item.usuarioRegistro.nomeCompleto),
    dataUltimaAtualizacao:
      formatDt(item.dataUltimaAtualizacao) +
      ' - ' +
      formataNomeMeioSiglas(item.usuarioAtualizacao.nomeCompleto),

    dataUltimaVisualizacao:
      formatDt(item.dataUltimaVisualizacao) +
      ' - ' +
      formataNomeMeioSiglas(item.usuarioUltimaVisualizacao.nomeCompleto),
    nEdicoes: item.nEdicoes,
    nVisualizacoes: item.nVisualizacoes,
    Status:
      item.status === 'S' ? (
        <CustomSpan texto="Ativo" />
      ) : (
        <CustomSpan texto="Inativo" />
      ),
    Alocação: unidadeDAF[item.unidadeDAF]?.label || 'Unidade Desconhecida',
    Setor: item.setor,
    'Data Início': formatDt(item.dataInicio),
    'Data Fim': item.dataFim ? formatDt(item.dataFim) : 'N/A',
  }));

  //TITULO MODAL
  let tituloModalAlocacao = '';
  if (updatingAlocacao) {
    tituloModalAlocacao = 'Atualizar Alocação';
  } else {
    tituloModalAlocacao = 'Novo Registro Alocação';
  }

  const iconeModalAlocacao = 'key';

  // Função Limpa formulario para Add nova Alocacao
  // const handleClearFormAlocacao = () => {
  //   setFormAlocacao({
  //     unidadeDAF: 0,
  //     setor: '',
  //     dataInicio: '',
  //     dataFim: '',
  //     observacoes: '',
  //     usuarioRegistroId: userID,
  //     alocacaoId: null,
  //     status: '0',
  //   });
  // };

  // Função Update e Create Alocacao
  const handleAddOrUpdateAlocacao = async () => {
    try {
      const usuarioId = parseInt(fichaID, 10);
      if (isNaN(usuarioId)) {
        throw new Error('O ID do usuário (fichaID) é inválido');
      }

      if (
        !formAlocacao.unidadeDAF ||
        !formAlocacao.setor ||
        !formAlocacao.dataInicio
      ) {
        swal('warning', 'Preencha todos os campos obrigatórios!', 'Atenção');
        return;
      }

      const newAlocacao = {
        usuarioId: usuarioId,
        usuarioRegistroId: userID,
        status: formAlocacao.status, // 'S' para Ativo e 'N' para Inativo
        unidadeDAF: formAlocacao.unidadeDAF,
        setor: formAlocacao.setor,
        dataInicio: `${formAlocacao.dataInicio}T00:00:00.000Z`,
        dataFim: formAlocacao.dataFim
          ? `${formAlocacao.dataFim}T00:00:00.000Z`
          : null,
        observacoes: formAlocacao.observacoes || '',
      };

      // Verificar se dataFim é posterior a dataInicio
      if (
        newAlocacao.dataFim &&
        new Date(newAlocacao.dataFim) < new Date(newAlocacao.dataInicio)
      ) {
        swalErro('A data de término não pode ser anterior à data de início.');
        return;
      }

      // Update ou Create Alocacao
      const method =
        updatingAlocacao && formAlocacao.alocacaoId ? 'patch' : 'post';
      const url = `/api/alocacaodaf${
        updatingAlocacao && formAlocacao.alocacaoId
          ? `/${formAlocacao.alocacaoId}`
          : ''
      }`;

      const response = await httpClient({
        method,
        url,
        data: newAlocacao,
      });

      if (response.status === 200 || response.status === 201) {
        // Recarregar dados e fechar modal
        const userAlocacaoData = await getUserAlocacao(fichaID);
        setAlocacoes(userAlocacaoData);

        const updatedUserData = await getUserData(fichaID);
        setFormData(updatedUserData);

        setShowModalAlocacao(false);
        swal(
          'success',
          response.data.message || 'Alocação registrada com sucesso!',
          'Sucesso',
        );
      } else {
        throw new Error('Erro ao adicionar ou atualizar alocação');
      }
    } catch (error) {
      if (isHttpError(error)) {
        console.error(
          'Erro ao adicionar ou atualizar alocação:',
          error.response?.data || error.message,
        );
        swalErro(
          error.response?.data?.message || 'Erro ao processar a alocação',
        );
      } else {
        console.error('Erro ao adicionar ou atualizar alocação:', error);
        swal('error', 'Erro desconhecido. Tente novamente.', 'Erro');
      }
    }
  };

  //DELETE
  const handleDeleteAlocacao = async () => {
    const result = await swalDelete();

    if (!result) {
      swalErro('A operação foi cancelada.');
      return;
    }

    try {
      const response = await httpClient.delete(
        `/api/alocacaodaf/${alocacaoIdToDelete}`,
      );

      // console.log('Response:', response);

      if (response.status === 200 || response.status === 204) {
        // Recarrega os dados após a exclusão
        const userAlocacaoData = await getUserAlocacao(fichaID);
        setAlocacoes(userAlocacaoData);

        const updatedUserData = await getUserData(fichaID);
        setFormData(updatedUserData);

        setShowModalAlocacao(false);

        swal(
          'success',
          response.data?.message || 'Alocação excluída com sucesso!',
          'Sucesso',
        );
      } else {
        throw new Error('Erro inesperado ao excluir alocação.');
      }
    } catch (error) {
      console.error('Erro ao excluir registro:', error);

      if (isHttpError(error)) {
        swalErro(error.response?.data?.message || 'Erro desconhecido');
      } else {
        swalErro('Não foi possível excluir o registro. Tente novamente.');
      }
    }
  };

  // MODULO PAPEL
  // Estado formulario
  const [formPapel, setFormPapel] = useState({
    papelUsuario: 0,
    dataInicio: '',
    dataFim: '',
    observacoes: '',
    usuarioRegistroId: userID,
    papelId: null,
    status: 'N',
    stRegistroAtivo: 'N',
  });

  // Mostrar modal para Add Papel
  // const handleClickInserirNovoPapel = () => {
  //   handleClearFormPapel();
  //   setUpdatingPapel(false);
  //   handleModalPapel();
  // };

  // Função trata linha ao clicar
  // const handleRowClickPapel = (id: number) => {
  //   const selectedPapel = papeis.find((item) => item.id === id);
  //   if (selectedPapel) {
  //     setPapelIdToDelete(id);
  //     setUpdatingPapel(true);
  //     setShowModalPapel(true);
  //     setFormPapel({
  //       papelUsuario: selectedPapel.papelUsuario,
  //       dataInicio: selectedPapel.dataInicio.split('T')[0],
  //       dataFim: selectedPapel.dataFim
  //         ? selectedPapel.dataFim.split('T')[0]
  //         : '',
  //       observacoes: selectedPapel.observacoes,
  //       usuarioRegistroId: userID,
  //       papelId: selectedPapel.id,
  //       status: selectedPapel.status,
  //       stRegistroAtivo: selectedPapel.stRegistroAtivo,
  //     });
  //     // Define os dados do log
  //     setLogDataPapel({
  //       id: selectedPapel.id,
  //       usuarioRegistro: selectedPapel.usuarioRegistro?.nomeCompleto || '',
  //       usuarioAtualizacao: selectedPapel.usuarioRegistro?.nomeCompleto || '',
  //       dataRegistro: selectedPapel.dataRegistro || '',
  //       dataAtualizacao: selectedPapel.dataUltimaAtualizacao || '',
  //       nEdicoes: selectedPapel.nEdicoes || 0,
  //     });
  //   }
  // };

  // TABELA HEADERS
  // const headersPapel = [
  //   { text: '', width: 2, key: '' },
  //   { text: 'ID', width: 2, key: 'id' },
  //   { text: 'Status', width: 2, key: 'status' },
  //   { text: 'Papel Usuário', width: 15, key: 'papelUsuario' },
  //   { text: 'Data Início', width: 15, key: 'dataInicio' },
  //   { text: 'Data Fim', width: 15, key: 'dataFim' },
  // ];

  // const tableDataPapel = papeis.map((item) => ({
  //   id: item.id,
  //   status: <BolinhaTabelaStatus status={item.status} />,
  //   'Papel Usuário':
  //     papelUsuario[item.papelUsuario]?.label || 'Papel não informado',
  //   'Data Início': formatDt(item.dataInicio),
  //   'Data Fim': item.dataFim ? formatDt(item.dataFim) : 'N/A',
  // }));

  const filteredPapeis = papeis.filter(
    (item) => item.status === 'S' && item.papelUsuario === 3,
  );

  // const offCanvasDataPapel = papeis.map((item) => ({
  //   id: item.id,
  //   dataRegistro:
  //     formatDt(item.dataRegistro) +
  //     ' - ' +
  //     formataNomeMeioSiglas(item.usuarioRegistro.nomeCompleto),
  //   dataUltimaAtualizacao:
  //     formatDt(item.dataUltimaAtualizacao) +
  //     ' - ' +
  //     formataNomeMeioSiglas(item.usuarioAtualizacao.nomeCompleto),

  //   dataUltimaVisualizacao:
  //     formatDt(item.dataUltimaVisualizacao) +
  //     ' - ' +
  //     formataNomeMeioSiglas(item.usuarioUltimaVisualizacao.nomeCompleto),
  //   nEdicoes: item.nEdicoes,
  //   nVisualizacoes: item.nVisualizacoes,
  //   Status:
  //     item.status === 'S' ? (
  //       <CustomSpan texto="Ativo" />
  //     ) : (
  //       <CustomSpan texto="Inativo" />
  //     ),
  //   'Papel Usuário':
  //     papelUsuario[item.papelUsuario]?.label || 'Papel não informado',
  //   'Data Início': formatDt(item.dataInicio),
  //   'Data Fim': item.dataFim ? formatDt(item.dataFim) : 'N/A',
  // }));

  // TITULO MODAL
  let tituloModalPapel = '';
  if (updatingPapel) {
    tituloModalPapel = 'Atualizar Papel';
  } else {
    tituloModalPapel = 'Novo Registro';
  }

  const iconeModalPapel = 'key';

  // Função Limpa formulario para Add novo Papel
  // const handleClearFormPapel = () => {
  //   setFormPapel({
  //     papelUsuario: 0,
  //     dataInicio: '',
  //     dataFim: '',
  //     observacoes: '',
  //     usuarioRegistroId: userID,
  //     papelId: null,
  //     status: '0',
  //     stRegistroAtivo: '0',
  //   });
  // };

  // Função Update e Create Papel
  const handleAddOrUpdatePapel = async () => {
    try {
      const usuarioId = parseInt(fichaID, 10);
      if (isNaN(usuarioId)) {
        throw new Error('O ID do usuário (fichaID) é inválido');
      }

      if (!formPapel.papelUsuario || !formPapel.dataInicio) {
        swal('warning', 'Preencha todos os campos obrigatórios!', 'Atenção');
        return;
      }

      const newPapel = {
        usuarioId: usuarioId,
        usuarioRegistroId: userID,
        status: formPapel.status, // 'S' para Ativo e 'N' para Inativo
        papelUsuario: formPapel.papelUsuario,

        dataInicio: `${formPapel.dataInicio}T00:00:00.000Z`,
        dataFim: formPapel.dataFim
          ? `${formPapel.dataFim}T00:00:00.000Z`
          : null,
        observacoes: formPapel.observacoes || '',
      };

      // Verificar se dataFim é posterior a dataInicio
      if (
        newPapel.dataFim &&
        new Date(newPapel.dataFim) < new Date(newPapel.dataInicio)
      ) {
        swalErro('A data de término não pode ser anterior à data de início.');
        return;
      }

      // Update ou Create Papel
      const method = updatingPapel && formPapel.papelId ? 'patch' : 'post';
      const url = `/api/papelsisaf${
        updatingPapel && formPapel.papelId ? `/${formPapel.papelId}` : ''
      }`;

      const response = await httpClient({
        method,
        url,
        data: newPapel,
      });

      if (response.status === 200 || response.status === 201) {
        // Recarregar dados e fechar modal
        const userPapelData = await getUserPapel(fichaID);
        setPapeis(userPapelData);

        const updatedUserData = await getUserData(fichaID);
        setFormData(updatedUserData);

        setShowModalPapel(false);

        swal(
          'success',
          response.data.message || 'Papel registrada com sucesso!',
          'Sucesso',
        );
      } else {
        throw new Error('Erro ao adicionar ou atualizar papel');
      }
    } catch (error) {
      if (isHttpError(error)) {
        console.error(
          'Erro ao adicionar ou atualizar papel:',
          error.response?.data || error.message,
        );
        swalErro(error.response?.data?.message || 'Erro ao processar a papel');
      } else {
        console.error('Erro ao adicionar ou atualizar papel:', error);
        swal('error', 'Erro desconhecido. Tente novamente.', 'Erro');
      }
    }
  };

  // DELETE
  const handleDeletePapel = async () => {
    const result = await swalDelete();
    let response: AxiosResponse;

    if (result) {
      try {
        response = await httpClient.delete(
          `/api/papelsisaf/${papelIdToDelete}`,
        );

        // Verifica o status da resposta
        if (response.status === 200 || response.status === 204) {
          // Recarrega os dados após a exclusão
          const userPapelData = await getUserPapel(fichaID);
          setPapeis(userPapelData);

          const updatedUserData = await getUserData(fichaID);
          setFormData(updatedUserData);

          setShowModalPapel(false);

          // Exibe mensagem de sucesso sem depender de response.data (para status 204)
          swal(
            'success',
            response.data?.message || 'Papel excluído com sucesso!',
            'Sucesso',
          );
        } else {
          throw new Error('Erro ao excluir papel');
        }
      } catch (error) {
        console.error('Erro ao excluir registro:', error); // Log detalhado do erro
        if (isHttpError(error)) {
          swalErro(error.response?.data?.message || 'Erro desconhecido');
        } else {
          swalErro('Não foi possível excluir o registro. Tente novamente.');
        }
      }
    } else {
      swalErro('A operação foi cancelada.');
    }
  };

  //MODULO PERMISSAO
  // const handleCheckboxChange = (
  //   e: React.ChangeEvent<HTMLInputElement>,
  //   field: keyof typeof formPermissao,
  // ) => {
  //   setFormPermissao({
  //     ...formPermissao,
  //     [field]: e.target.checked,
  //   });
  // };

  // Estado formulario
  // const [formPermissao, setFormPermissao] = useState({
  //   moduloUsuario: 0,
  //   create: false,
  //   read: false,
  //   update: false,
  //   delete: false,
  //   observacoes: '',
  //   usuarioRegistroId: userID,
  //   permissaoId: null,
  //   status: 'N',
  // });

  // Mostrar modal para Add Permissao
  // const handleClickInserirNovoPermissao = () => {
  //   handleClearFormPermissao();
  //   setUpdatingPermissao(false);
  //   handleModalPermissao();
  // };

  // Função trata linha ao clicar
  // const handleRowClickPermissao = (id: number) => {
  //   const selectedPermissao = permissoes.find((item) => item.id === id);
  //   if (selectedPermissao) {
  //     setPermissaoIdToDelete(id);
  //     setUpdatingPermissao(true);
  //     setShowModalPermissao(true);
  //     setFormPermissao({
  //       moduloUsuario: selectedPermissao.moduloUsuario,
  //       create: selectedPermissao.create,
  //       read: selectedPermissao.read,
  //       update: selectedPermissao.update,
  //       delete: selectedPermissao.delete,
  //       observacoes: selectedPermissao.observacoes,
  //       usuarioRegistroId: userID,
  //       permissaoId: selectedPermissao.id,
  //       status: selectedPermissao.status,
  //     });
  //     // Define os dados do log
  //     setLogDataPermissao({
  //       id: selectedPermissao.id,
  //       usuarioRegistro: selectedPermissao.usuarioRegistro?.nomeCompleto || '',
  //       usuarioAtualizacao:
  //         selectedPermissao.usuarioRegistro?.nomeCompleto || '',
  //       dataRegistro: selectedPermissao.dataRegistro || '',
  //       dataAtualizacao: selectedPermissao.dataUltimaAtualizacao || '',
  //       nEdicoes: selectedPermissao.nEdicoes || 0,
  //     });
  //   }
  // };

  //TABELA HEADERS
  // const headersPermissao = [
  //   { text: '', width: 2, key: '' },
  //   { text: 'ID', width: 2, key: 'id' },
  //   { text: 'Status', width: 1, key: 'status' },
  //   { text: 'Modulo', width: 15, key: 'moduloUsuario' },
  //   { text: 'Create', width: 15, key: 'create' },
  //   { text: 'Read', width: 15, key: 'read' },
  //   { text: 'Update', width: 15, key: 'update' },
  //   { text: 'Delete', width: 15, key: 'delete' },
  // ];

  // const tableDataPermissao = permissoes.map((item) => ({
  //   id: item.id,
  //   status: <BolinhaTabelaStatus status={item.status} />,
  //   Modulo: moduloUsuario[item.moduloUsuario]?.label || 'Modulo Desconhecida',
  //   Create: item.create ? 'Sim' : 'Não',
  //   Read: item.read ? 'Sim' : 'Não',
  //   Update: item.update ? 'Sim' : 'Não',
  //   Delete: item.delete ? 'Sim' : 'Não',
  // }));

  // const offCanvasDataPermissao = permissoes.map((item) => ({
  //   id: item.id,
  //   dataRegistro:
  //     formatDt(item.dataRegistro) +
  //     ' - ' +
  //     formataNomeMeioSiglas(item.usuarioRegistro.nomeCompleto),
  //   dataUltimaAtualizacao:
  //     formatDt(item.dataUltimaAtualizacao) +
  //     ' - ' +
  //     formataNomeMeioSiglas(item.usuarioAtualizacao.nomeCompleto),

  //   dataUltimaVisualizacao:
  //     formatDt(item.dataUltimaVisualizacao) +
  //     ' - ' +
  //     formataNomeMeioSiglas(item.usuarioUltimaVisualizacao.nomeCompleto),
  //   nEdicoes: item.nEdicoes,
  //   nVisualizacoes: item.nVisualizacoes,
  //   Status:
  //     item.status === 'S' ? (
  //       <CustomSpan texto="Ativo" />
  //     ) : (
  //       <CustomSpan texto="Inativo" />
  //     ),
  //   Modulo: moduloUsuario[item.moduloUsuario]?.label || 'Modulo Desconhecida',
  //   Create: item.create ? 'Sim' : 'Não',
  //   Read: item.read ? 'Sim' : 'Não',
  //   Update: item.update ? 'Sim' : 'Não',
  //   Delete: item.delete ? 'Sim' : 'Não',
  // }));

  // Função Limpa formulario para Add nova Permissao
  // const handleClearFormPermissao = () => {
  //   setFormPermissao({
  //     moduloUsuario: 0,
  //     create: false,
  //     read: false,
  //     update: false,
  //     delete: false,
  //     observacoes: '',
  //     usuarioRegistroId: userID,
  //     permissaoId: null,
  //     status: '0',
  //   });
  // };

  // Função Update e Create Permissao
  // const handleAddOrUpdatePermissao = async () => {
  //   try {
  //     const token = localStorage.getItem('token');
  //     if (!token) throw new Error('Access token not found');

  //     const usuarioId = parseInt(fichaID, 10);
  //     if (isNaN(usuarioId)) {
  //       throw new Error('O ID do usuário (fichaID) é inválido');
  //     }

  //     if (!formPermissao.moduloUsuario) {
  //       swal('warning', 'Preencha todos os campos obrigatórios!', 'Atenção');
  //       return;
  //     }

  //     const newPermissao = {
  //       usuarioId,
  //       usuarioRegistroId: userID,
  //       status: formPermissao.status === '0' ? 'S' : formPermissao.status,
  //       moduloUsuario: formPermissao.moduloUsuario,
  //       create: formPermissao.create,
  //       read: formPermissao.read,
  //       update: formPermissao.update,
  //       delete: formPermissao.delete,
  //       observacoes: formPermissao.observacoes ? formPermissao.observacoes : '',
  //     };

  //     // Update ou Create Permissao
  //     let response: AxiosResponse;
  //     if (updatingPermissao && formPermissao.permissaoId) {
  //       response = await axios.patch(
  //         `${process.env.REACT_APP_API_URL}/api/permissoesmodulos/${formPermissao.permissaoId}`,
  //         newPermissao,
  //         { headers: { Authorization: `Bearer ${token}` } },
  //       );
  //     } else {
  //       response = await axios.post(
  //         `${process.env.REACT_APP_API_URL}/api/permissoesmodulos`,
  //         newPermissao,
  //         { headers: { Authorization: `Bearer ${token}` } },
  //       );
  //     }

  //     if (response.status === 200 || response.status === 201) {
  //       // Recarrega os dados e fecha o modal
  //       const userPermissaoData = await getUserPermissao(fichaID);
  //       setPermissoes(userPermissaoData);
  //       setShowModalPermissao(false);

  //       swal(
  //         'success',
  //         response.data.message || 'Permissão registrada com sucesso!',
  //         'Sucesso',
  //       );
  //     } else {
  //       throw new Error('Erro ao adicionar ou atualizar permissão');
  //     }
  //   } catch (error) {
  //     // Tratar erros adequadamente
  //     if (axios.isAxiosError(error)) {
  //       console.error(
  //         'Erro ao adicionar ou atualizar permissão:',
  //         error.response?.data || error.message,
  //       );
  //       swal(
  //         'error',
  //         error.response?.data?.message || 'Erro ao processar a permissão',
  //         'Erro',
  //       );
  //     } else {
  //       console.error('Erro ao adicionar ou atualizar permissão:', error);
  //       swal('error', 'Erro desconhecido. Tente novamente.', 'Erro');
  //     }
  //   }
  // };

  // DELETE
  // const handleDeletePermissao = async () => {
  //   const result = await swalDelete();
  //   let response: AxiosResponse;
  //   if (result) {
  //     try {
  //       const token = localStorage.getItem('token');
  //       response = await axios.delete(
  //         `${process.env.REACT_APP_API_URL}/api/permissoesmodulos/${permissaoIdToDelete}`,
  //         {
  //           headers: {
  //             Authorization: `Bearer ${token}`,
  //           },
  //         },
  //       );
  //       if (response.status === 200 || response.status === 201) {
  //         // Recarrega os dados e fecha o modal
  //         const userPermissaoData = await getUserPermissao(fichaID);
  //         setPermissoes(userPermissaoData);
  //         setShowModalPermissao(false);

  //         swal(
  //           'success',
  //           response.data.message || 'Permissão excluída com sucesso!',
  //           'Sucesso',
  //         );
  //       } else {
  //         throw new Error('Erro ao excluir permissão');
  //       }
  //     } catch (error) {
  //       if (axios.isAxiosError(error)) {
  //         swalErro(error.response?.data.message);
  //       }
  //       console.error('Erro ao excluir permissão', error);
  //       swalErro('Não foi possível excluir o registro. Tente novamente.');
  //     }
  //   } else {
  //     swalErro('A operação falhou.');
  //   }
  // };

  // Condição para verificar se o papel do usuário é "técnico"
  // const isUserTecnico =
  //   formPapel.papelUsuario === 3 && formPapel.stRegistroAtivo === 'S';
  // useEffect(() => {
  //   // console.log('isUserTecnico:', isUserTecnico);
  // }, [formPapel.papelUsuario, formPapel.stRegistroAtivo]);

  let subAbas: { label: string; rota: string }[] = [];

  if (fichaID !== 'undefined') {
    subAbas = SubAbasUser(fichaID);
  } else {
    subAbas = [
      {
        label: 'Dados Gerais',
        rota: '#',
      },
    ];
  }

  ///
  const [statusStyleUsuario, setStatusStyleUsuario] =
    useState<React.CSSProperties>({});
  const [statusStyleAlocacao, setStatusStyleAlocacao] =
    useState<React.CSSProperties>({});
  const [statusStylePapel, setStatusStylePapel] = useState<React.CSSProperties>(
    {},
  );

  useEffect(() => {
    const verde = '#abf3aba7';
    const vermelho = '#ffcecec3';

    setStatusStyleUsuario({
      backgroundColor: formData.stRegistroAtivo === 'S' ? verde : vermelho,
    });
  }, [formData.stRegistroAtivo]);

  useEffect(() => {
    const verde = '#abf3aba7';
    const vermelho = '#ffcecec3';

    setStatusStyleAlocacao({
      backgroundColor: formAlocacao.status === 'S' ? verde : vermelho,
    });
  }, [formAlocacao.status]);

  useEffect(() => {
    const verde = '#abf3aba7';
    const vermelho = '#ffcecec3';

    setStatusStylePapel({
      backgroundColor: formPapel.status === 'S' ? verde : vermelho,
    });
  }, [formPapel.status]);

  // const hasActiveAlocacao = alocacoes.some(
  //   (alocacao) => alocacao.status === 'S',
  // );
  // const hasActivePapel = papeis.some((papel) => papel.status === 'S');

  //PERMISSOES-MODULOS
  // const papelUsuarioOptions = usePapelUsuario();
  // const moduloUsuarioOptions = useModuloUsuario();

  // const MODULO = Number(
  //   moduloUsuarioOptions.find(
  //     (modulo) => modulo.label === 'Produtos Farmacêuticos',
  //   )?.value || '0',
  // );

  // const canRelatorio = isActionAllowed(MODULO, 'read', papelUsuarioOptions);
  // const [showRelatorio, setShowRelatorio] = useState(false);
  // const handleShowRelatorio = () => setShowRelatorio(!showRelatorio);

  // Função para gerar o PDF
  /* const gerarPDF = () => {
    const doc = new jsPDF();

    doc.setFontSize(16);
    doc.text('Relatório do Usuário', 10, 10);
    doc.setFontSize(12);

    const formDataSafe = formData || {};

    doc.text(`Nome: ${formDataSafe.nomeCompleto || 'Não informado'}`, 10, 30);
    doc.text(`CPF: ${formDataSafe.cpf || 'Não informado'}`, 10, 40);
    doc.text(
      `Data de Nascimento: ${formDataSafe.dataNascimento || 'Não informado'}`,
      10,
      50,
    );

    // Converte o PDF em um blob
    const pdfBlob = doc.output('blob');

    // Criar um link temporário para download
    const pdfUrl = URL.createObjectURL(pdfBlob);

    // **Opção 1: Abrir em uma nova aba**
    window.open(pdfUrl, '_blank');

    // **Opção 2: Forçar o download do arquivo**
    const a = document.createElement('a');
    a.href = pdfUrl;
    a.download = `Relatorio_${formDataSafe.nomeCompleto || 'usuario'}.pdf`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };
*/
  return (
    <>
      <SubAbas>
        <StyledLink
          to="/fornecedor/adm/usuarios"
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center',
            cursor: 'pointer',
          }}
        >
          <span className="material-icons">arrow_back</span>
        </StyledLink>
        <BarraSubAbas subAbas={subAbas} />
      </SubAbas>
      <ContainerConteudo>
        <WorkspaceFicha>
          <Modal
            icone={iconeModal}
            tituloModal={tituloModal}
            open={showModal}
            onHide={handleModal}
            modalSize="medio"
          >
            <div className="d-flex form flex-column justify-content-center align-items-center gap-4 m-3">
              <Input
                name="senha"
                id="senha"
                value={senha}
                label="Nova Senha"
                onChange={handleSenhaChange}
                onBlur={validaSenhaTamanho}
                type="password"
              />
              <Input
                name="confirmaSenha"
                value={confirmaSenha}
                label="Confirma Senha"
                id="confirmaSenha"
                onChange={handleConfirmaSenhaChange}
                type="password"
                onBlur={validaSenhaConfirma}
              />
              <WorkspaceBotoes
                cancelar
                onClickCancelar={handleModal}
                save
                onClickSave={updateSenha}
              />
            </div>
          </Modal>
          {/* <UploadSimples
            modulo="usuario"
            registroId={Number(id)}
            maxFileSizeMB={5}
            allowedExtensions={['pdf', 'doc', 'docx', 'jpg', 'jpeg', 'png']}
          /> */}
          {/* <UploadMultiple
            modulo="usuario"
            registroId={Number(id)}
            maxFileSizeMB={5}
            allowedExtensions={['pdf', 'doc', 'docx', 'jpg', 'jpeg', 'png']}
          /> */}

          <BoxConteudo boxTitulo="Dados do Usuário">
            <CustomRow style={{ marginTop: '-15px' }}>
              <CustomCol width="12%">
                <SelectInput
                  name="stRegistroAtivo"
                  options={[
                    { label: 'Ativo', value: 'S' },
                    { label: 'Inativo', value: 'N' },
                  ]}
                  label="Status"
                  value={formData.stRegistroAtivo === 'S' ? 'S' : 'N'}
                  onChange={handleChange}
                  style={statusStyleUsuario}
                  disabled
                />
              </CustomCol>

              <CustomCol width="13%">
                <Input
                  name="cpf"
                  mascara="cpf"
                  value={formData.cpf}
                  id="cpf"
                  label="CPF"
                  onChange={handleChange}
                  readonly
                />
              </CustomCol>
              <CustomCol width="32%">
                <Input
                  name="nomeCompleto"
                  value={formData.nomeCompleto || ''}
                  id="nome"
                  label="Nome completo"
                  onChange={handleChange}
                  readonly
                />
              </CustomCol>
              <CustomCol>
                <Input
                  name="dataNascimento"
                  type="date"
                  value={formData.dataNascimento}
                  id="dataNascimento"
                  label="Data de nascimento"
                  onChange={handleChange}
                  readonly
                />
              </CustomCol>
              <CustomCol>
                <Select
                  name="genero"
                  value={formData.genero.toString()}
                  onChange={handleChange}
                  options={generos}
                  label="Selecione o gênero"
                  disabled
                />
              </CustomCol>
              <CustomCol>
                <Select
                  name="cor"
                  value={formData.cor.toString()}
                  onChange={handleChange}
                  options={cores}
                  label="Cor da pele"
                  disabled
                />
              </CustomCol>
            </CustomRow>
            <CustomRow>
              <CustomCol width="13%">
                <Input
                  name="celular"
                  mascara="celular"
                  value={formData.celular}
                  id="celular"
                  label="Celular"
                  onChange={handleChange}
                  readonly
                />
              </CustomCol>

              <CustomCol>
                <Input
                  name="emailPessoal"
                  value={formData.emailPessoal}
                  id="emailPessoal"
                  label="Email pessoal"
                  onChange={handleChange}
                  readonly
                />
              </CustomCol>
              <CustomCol>
                <Input
                  name="emailInstitucional"
                  value={formData.emailInstitucional}
                  id="emailInstitucional"
                  label="Email institucional"
                  onChange={handleChange}
                  readonly
                />
              </CustomCol>
              <CustomCol>
                <Input
                  name="linkedin"
                  value={formData.linkedin}
                  id="linkedin"
                  label="LinkedIn"
                  onChange={handleChange}
                  readonly
                />
              </CustomCol>
              <CustomCol>
                <Input
                  name="lattes"
                  value={formData.lattes}
                  id="lattes"
                  label="Lattes"
                  onChange={handleChange}
                  readonly
                />
              </CustomCol>
            </CustomRow>
          </BoxConteudo>

          <Modal
            icone={iconeModalAlocacao}
            tituloModal={tituloModalAlocacao}
            open={showModalAlocacao}
            onHide={handleModalAlocacao}
            modalSize="medio"
            size="lg"
          >
            {updatingAlocacao && <Log {...logDataAlocacao} />}
            <WorkspaceFicha>
              <CustomRow style={{ marginTop: '10px' }}>
                <CustomCol>
                  <Select
                    name="status"
                    value={formAlocacao.status}
                    onChange={(e) => {
                      const newStatus = e.target.value;
                      setFormAlocacao({
                        ...formAlocacao,
                        status: newStatus,
                        dataFim: newStatus === 'S' ? '' : formAlocacao.dataFim,
                      });
                    }}
                    options={[
                      { label: 'Inativo', value: 'N' },
                      { label: 'Ativo', value: 'S' },
                    ]}
                    label="Status"
                    style={statusStyleAlocacao}
                  />
                </CustomCol>
              </CustomRow>
              <CustomRow>
                <CustomCol>
                  <Input
                    name="dataInicio"
                    type="date"
                    value={formAlocacao.dataInicio}
                    id="dataInicio"
                    label="Data Início"
                    onChange={(e) =>
                      setFormAlocacao({
                        ...formAlocacao,
                        dataInicio: e.target.value,
                      })
                    }
                  />
                </CustomCol>
                <CustomCol>
                  <Input
                    name="dataFim"
                    type="date"
                    value={formAlocacao.dataFim}
                    id="dataFim"
                    label="Data Fim"
                    onChange={(e) =>
                      setFormAlocacao({
                        ...formAlocacao,
                        dataFim: e.target.value,
                      })
                    }
                    placeholder="Opcional"
                    readonly={formAlocacao.status === 'S'}
                  />
                </CustomCol>
              </CustomRow>
              <CustomRow>
                <CustomCol width="100%" height="100%">
                  <Input
                    id="observacoes"
                    name="observacoes"
                    value={formAlocacao.observacoes}
                    label="Observações Gerais"
                    type="textarea"
                    onChange={(e) =>
                      setFormAlocacao({
                        ...formAlocacao,
                        observacoes: e.target.value,
                      })
                    }
                  />
                </CustomCol>
              </CustomRow>
              <BarraInferiorBotoes>
                <WorkspaceBotoes
                  delete={updatingAlocacao}
                  onClickDelete={handleDeleteAlocacao}
                  save
                  onClickSave={handleAddOrUpdateAlocacao}
                  cancelar
                  onClickCancelar={handleModalAlocacao}
                />
              </BarraInferiorBotoes>
            </WorkspaceFicha>
          </Modal>

          <BoxConteudo boxTitulo="Histórico de Vinculação 11">
            <Tabela
              headers={headersAlocacao}
              dataTable={tableDataAlocacao}
              dataOffCanvas={offCanvasDataAlocacao}
              onRowClick={handleRowClickAlocacao}
              displayValues={valoresExibidos}
              showPagination={false}
            />
          </BoxConteudo>

          <Modal
            icone={iconeModalPapel}
            tituloModal={tituloModalPapel}
            open={showModalPapel}
            onHide={handleModalPapel}
            modalSize="medio"
            size="lg"
          >
            <WorkspaceFicha>
              {updatingPapel && <Log {...logDataPapel} />}
              <CustomRow style={{ marginTop: '10px' }}>
                <CustomCol width="50%">
                  <Select
                    name="status"
                    value={formPapel.status}
                    onChange={(e) => {
                      const newStatus = e.target.value;
                      setFormPapel({
                        ...formPapel,
                        status: newStatus,
                        dataFim: newStatus === 'S' ? '' : formPapel.dataFim,
                      });
                    }}
                    options={[
                      { label: 'Inativo', value: 'N' },
                      { label: 'Ativo', value: 'S' },
                    ]}
                    label="Status"
                    style={statusStylePapel}
                  />
                </CustomCol>
                <CustomCol width="50%">
                  <Select
                    name="papelUsuario"
                    value={formPapel.papelUsuario}
                    onChange={(e) =>
                      setFormPapel({
                        ...formPapel,
                        papelUsuario: parseInt(e.target.value, 10),
                      })
                    }
                    options={papelUsuario.filter((option) => {
                      // Filtra "Admin" (value === 1) apenas para usuários que não são administradores
                      if (
                        parseInt(String(userRole || '0'), 10) !== 1 && // Converte para string antes de usar parseInt
                        parseInt(option.value, 10) === 1 // Filtra a opção Admin (value === 1)
                      ) {
                        return false; // Remove a opção "Admin"
                      }
                      return true; // Exibe as demais opções
                    })}
                    label="Papel Usuário"
                  />
                </CustomCol>
              </CustomRow>
              <CustomRow>
                <CustomCol width="50%">
                  <Input
                    name="dataInicio"
                    type="date"
                    value={formPapel.dataInicio}
                    id="dataInicio"
                    label="Data Início"
                    onChange={(e) =>
                      setFormPapel({
                        ...formPapel,
                        dataInicio: e.target.value,
                      })
                    }
                  />
                </CustomCol>
                <CustomCol width="50%">
                  <Input
                    name="dataFim"
                    type="date"
                    value={formPapel.dataFim}
                    id="dataFim"
                    label="Data Fim"
                    onChange={(e) =>
                      setFormPapel({
                        ...formPapel,
                        dataFim: e.target.value,
                      })
                    }
                    required
                    placeholder="Opcional"
                    readonly={formPapel.status === 'S'}
                  />
                </CustomCol>
              </CustomRow>
              <CustomRow style={{ marginTop: '10px' }}>
                <CustomCol width="100%">
                  <Input
                    id="observacoes"
                    name="observacoes"
                    value={formPapel.observacoes}
                    label="Observações Gerais"
                    type="textarea"
                    onChange={(e) =>
                      setFormPapel({
                        ...formPapel,
                        observacoes: e.target.value,
                      })
                    }
                  />
                </CustomCol>
              </CustomRow>
              <BarraInferiorBotoes>
                <WorkspaceBotoes
                  delete={updatingPapel}
                  onClickDelete={handleDeletePapel}
                  save
                  onClickSave={handleAddOrUpdatePapel}
                  cancelar
                  onClickCancelar={handleModalPapel}
                />
              </BarraInferiorBotoes>
            </WorkspaceFicha>
          </Modal>
        </WorkspaceFicha>
      </ContainerConteudo>

      <BarraInferiorBotoes>
        <WorkspaceBotoes
          save //    criar desvinculação
          onClickSave={updateData}
        />
      </BarraInferiorBotoes>
    </>
  );
};
export default FichaUsuario;
